import { css } from '@emotion/react';

const fundCodeTableStyle = css`
    font-family: var(--font-family-regular);
    background-color: var(--default-background-color);
    color: var(--default-text-color);
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-regular);

    .fund-codes-table {
        text-align: center;
        width: 100%;

        thead {
            tr {
                border: 1px solid;
                border-bottom: none;
                border-left: none;
                border-color: var(--color-white);

                &:first-of-type {
                    border-top: none;

                    th:last-child {
                        border-right: none;
                    }
                }

                .child-columns-header {
                    text-align: center !important;
                }

                th {
                    background-color: var(--color-grey);
                    border-right: 1px solid var(--color-white);

                    &:first-of-type {
                        text-align: left;
                    }
                }
            }
        }

        tbody {
            td {
                &:first-of-type {
                    text-align: left;
                }
            }

            .group-row {
                background-color: var(--color-grey-light);
                text-align: left;
            }

            .fund-data-row {
                border-bottom: 1px solid var(--color-grey-light);
            }
        }
    }
`;
export default fundCodeTableStyle;
